import { Form, Input, Select, Table } from 'antd';
import React, { useContext, useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { fetchInvitedmembers, fetchUserById } from '../../../../features/fetch/fetchSlice';

export default function AddMemberSUbStepTable({ getMemberInvites }) {
    const dispatch = useDispatch();

    const { newChamaData } = useSelector((state) => state.obj);
    const { invitedMembers, roles } = useSelector((state) => state.fetch);

    const [dataSource, setDataSource] = useState(invitedMembers);
    const [showBorder, setshowBorder] = useState(true);
    const [selectedRowKeys, setSelectedRowKeys] = useState([]);

    const initialmemberInvite = {
        idNo: 'Enter National ID',
        name: 'Enter name',
        email: 'Enter email',
        phone: 'Enter phone number',
        role: 'MEMBER',
    };

    const onSelectChange = (newSelectedRowKeys) => {
        setSelectedRowKeys(newSelectedRowKeys);
    };

    const rowSelection = {
        selectedRowKeys,
        onChange: onSelectChange,
    };

    function handleRemove() {
        const updatedDataSource = dataSource?.filter((item) => !selectedRowKeys.includes(item?.mbiId));
        setSelectedRowKeys([]);
        setDataSource(updatedDataSource);
    }

    function handleToggleBorder() {
        setshowBorder(!showBorder);
    }

    async function handleFetch() {
        await dispatch(fetchInvitedmembers(newChamaData?.custId));
    }

    const EditableContext = React.createContext(null);
    const EditableRow = ({ index, ...props }) => {
        const [form] = Form.useForm();
        return (
            <Form form={form} component={false}>
                <EditableContext.Provider value={form}>
                    <tr {...props} />
                </EditableContext.Provider>
            </Form>
        );
    };

    const EditableCell = ({ title, editable, children, dataIndex, record, handleSave, handleSHowBorder, ...restProps }) => {
        const [editing, setEditing] = useState(false);
        const inputRef = useRef(null);
        const form = useContext(EditableContext);

        useEffect(() => {
            if (editing) {
                inputRef.current?.focus();
            }
        }, [editing]);

        const toggleEdit = () => {
            setEditing(true);
            form.setFieldsValue({
				...record,
                mbiEmail: record?.mbiEmail === "Enter email" ?  null : record?.mbiEmail,
                mbiNationalId: record?.mbiNationalId === "Enter National ID" ?  null : record?.mbiNationalId,
                mbiName: record?.mbiName === "Enter name" ?  null : record?.mbiName,
                mbiPhone: record?.mbiPhone === "Enter phone number" ?  null : record?.mbiPhone,
            });			
        };

        async function handleCheckId(id) {
            if (id?.replace(/\s+/g, '')?.length > 0) {
                const res = await dispatch(fetchUserById(id));
                if (res?.payload?.success) {
                    let { usrNationalId, usrMobileNumber, usrEmail, usrFirstname, usrLastname } = await res?.payload?.data?.result;

                    const mbiObj = {
                        mbiId: record?.mbiId,
                        mbiNationalId: usrNationalId,
                        mbiName: usrFirstname + ' ' + usrLastname,
                        mbiEmail: usrEmail,
                        mbiPhone: usrMobileNumber,
                    };

                    let newRecords = { ...record, ...mbiObj };

                    record = newRecords;

                    await save();
                } else {
                    const mbiObj = {
                        ...record,
                        mbiNationalId: id,
                    };

                    let newRecords = { ...record, ...mbiObj };
                    record = newRecords;
                    await save();
                }
            } else {
                const mbiObj = {
                    ...record,
                    mbiNationalId: 'Enter National ID',
                };

                let newRecords = { ...record, ...mbiObj };
                record = newRecords;
                await save();
            }
        }


        const save = async () => {
            try {
                const values = await form.validateFields();
                let row = { ...record, ...values };
                toggleEdit();
                handleSave(row);
            } catch (errInfo) {
                console.log('Save failed:', errInfo);
            }
        };

        let childNode = children;
        if (editable) {
            childNode = editing ? (
                dataIndex === 'mbiRole' ? (
                    <Form.Item
                        rules={[
                            {
                                required: true,
                                message: 'Field is required',
                            },
                        ]}
                        className="table-form-item"
                        style={{
                            margin: 0,
                        }}
                        name={dataIndex}
                    >
                        <Select
                            onBlur={save}
                            ref={inputRef}
                            placeholder={initialmemberInvite.role}
                            suffixIcon={
                                <svg xmlns="http://www.w3.org/2000/svg" width="21" height="21" viewBox="0 0 21 21" fill="none">
                                    <path
                                        d="M17.1922 8.21268L10.9422 14.4627C10.8841 14.5208 10.8152 14.5669 10.7393 14.5983C10.6634 14.6298 10.5821 14.646 10.5 14.646C10.4178 14.646 10.3365 14.6298 10.2606 14.5983C10.1848 14.5669 10.1158 14.5208 10.0578 14.4627L3.80779 8.21268C3.69052 8.0954 3.62463 7.93634 3.62463 7.77049C3.62463 7.60464 3.69052 7.44558 3.80779 7.3283C3.92507 7.21103 4.08413 7.14514 4.24998 7.14514C4.41583 7.14514 4.57489 7.21103 4.69217 7.3283L10.5 13.1369L16.3078 7.3283C16.3659 7.27023 16.4348 7.22417 16.5107 7.19274C16.5865 7.16132 16.6679 7.14514 16.75 7.14514C16.8321 7.14514 16.9134 7.16132 16.9893 7.19274C17.0652 7.22417 17.1341 7.27023 17.1922 7.3283C17.2502 7.38637 17.2963 7.45531 17.3277 7.53118C17.3592 7.60705 17.3753 7.68837 17.3753 7.77049C17.3753 7.85261 17.3592 7.93393 17.3277 8.0098C17.2963 8.08567 17.2502 8.15461 17.1922 8.21268Z"
                                        fill="#212121"
                                    />
                                </svg>
                            }
                            options={[
                                ...roles?.map((item, index) => ({
                                    label: item?.roleName,
                                    value: item?.roleName,
                                })),
                            ]}
                        />
                    </Form.Item>
                ) : dataIndex === 'mbiEmail' ? (
                    <Form.Item
                        rules={[
                            {
                                required: true,
                                message: 'Field is required',
                            },
                            {
                                type: 'email',
                                message: 'Enter valid email',
                            },
                        ]}
                        className="table-form-item"
                        style={{
                            margin: 0,
                        }}
                        name={dataIndex}
                    >
                        <Input
                            placeholder={initialmemberInvite.email}
                            id="input-focus"
                            className="input-borderless"
                            type="email"
                            variant="borderless"
                            ref={inputRef}
                            onPressEnter={save}
                            onBlur={save}
                            onChange={(e) => form.setFieldsValue({ [dataIndex]: e.target.value })}
                        />
                    </Form.Item>
                ) : dataIndex === 'mbiPhone' ? (
                    <Form.Item
                        rules={[
                            {
                                required: true,
                                message: 'Field is required',
                            },
                            {
								validator: (_, value) => {									
									if (value && value.length === 10) {
										return Promise.resolve();
									}
									return Promise.reject(
										new Error(
											'Phone number must be exactly 10 characters'
										)
									);
								},
							},
                        ]}
                        className="table-form-item"
                        style={{
                            margin: 0,
                        }}
                        name={dataIndex}
                    >
                        <Input
                            placeholder={initialmemberInvite.phone}
                            id="input-focus"
                            className="input-borderless"
                            variant="borderless"
                            ref={inputRef}
                            onPressEnter={save}
                            onBlur={save}
                            onChange={(e) => form.setFieldsValue({ [dataIndex]: e.target.value })}
                        />
                    </Form.Item>
                ) : dataIndex === 'mbiNationalId' ? (
                    <Form.Item
                        rules={[
                            {
                                required: true,
                                message: 'Field is required',
                            },
                        ]}
                        className="table-form-item"
                        style={{
                            margin: 0,
                        }}
                        name={dataIndex}
                    >
                        <Input
                            maxLength={9}
                            placeholder={initialmemberInvite.idNo}
                            id="input-focus"
                            className="input-borderless"
                            variant="borderless"
                            ref={inputRef}
                            onPressEnter={(e) => {
                                handleCheckId(e.target.value);
                            }}
                            onBlur={(e) => {
                                handleCheckId(e.target.value);
                            }}
                            onChange={(e) => {
                                form.setFieldsValue({ [dataIndex]: e.target.value });
                            }}
                        />
                    </Form.Item>
                ) : (
                    <Form.Item
                        rules={[
                            {
                                required: true,
                                message: 'Field is required',
                            },
                        ]}
                        className="table-form-item"
                        style={{
                            margin: 0,
                        }}
                        name={dataIndex}
                    >
                        <Input
                            placeholder={initialmemberInvite.name}
                            id="input-focus"
                            className="input-borderless"
                            variant="borderless"
                            ref={inputRef}
                            onPressEnter={save}
                            onBlur={save}
                            onChange={(e) => form.setFieldsValue({ [dataIndex]: e.target.value })}
                        />
                    </Form.Item>
                )
            ) : (
                <div
                    className="editable-cell-value-wrap"
                    style={{
                        paddingRight: 24,
                    }}
                    onClick={() => {
                        toggleEdit();
                    }}
                >
                    {children}
                </div>
            );
        }
        return <td {...restProps}>{childNode}</td>;
    };

    const handleAdd = async () => {
        const newData = {
            mbiId: new Date().getTime(),
            mbiNationalId: initialmemberInvite.idNo,
            mbiName: initialmemberInvite.name,
            mbiEmail: initialmemberInvite.email,
            mbiPhone: initialmemberInvite.phone,
            mbiRole: initialmemberInvite.role,
        };

        setDataSource([...dataSource, newData]);
    };

    const defaultColumns = [
        {
            title: 'Member’s ID Number',
            dataIndex: 'mbiNationalId',
            editable: true,
        },
        {
            title: 'Name',
            dataIndex: 'mbiName',
            editable: true,
        },
        {
            title: 'Email',
            dataIndex: 'mbiEmail',
            editable: true,
        },
        {
            title: 'Phone',
            dataIndex: 'mbiPhone',
            editable: true,
        },
        {
            title: 'Assign Role (optional)',
            dataIndex: 'mbiRole',
            render: (item) => (
                <div className="flex items-center justify-center gap-[.5rem] px-[.5rem] py-[.25rem] bg-[#E7F4E7]">
                    <svg xmlns="http://www.w3.org/2000/svg" width="5" height="4" viewBox="0 0 5 4" fill="none">
                        <circle cx="2.2002" cy="2" r="2" fill="#212121" />
                    </svg>
                    <span>{item}</span>
                </div>
            ),
            editable: true,
        },
    ];

    const handleSave = async (row) => {
        const newData = [...dataSource];
        const index = newData.findIndex((item) => row.mbiId === item.mbiId);
        const item = newData[index];
        newData.splice(index, 1, {
            ...item,
            ...row,
        });
        setDataSource(newData);
    };

    const components = {
        body: {
            row: EditableRow,
            cell: EditableCell,
        },
    };
    const columns = defaultColumns.map((col) => {
        if (!col.editable) {
            return col;
        }
        return {
            ...col,
            onCell: (record) => ({
                record,
                editable: col.editable,
                dataIndex: col.dataIndex,
                title: col.title,
                handleSave,
                handleSHowBorder: handleToggleBorder,
            }),
        };
    });

    useEffect(() => {
        getMemberInvites(dataSource);
    }, [dataSource]);

    useEffect(() => {
        handleFetch();
    }, []);

    return (
        <>
            <div className="max-w-full w-full overflow-x-auto">
                <section>
                    <Table
                        className="editable_table"
                        size={'large'}
                        bordered={false}
                        rowSelection={rowSelection}
                        columns={columns}
                        components={components}
                        dataSource={dataSource}
                        rowKey={'mbiId'}
                        scroll={{
                            x: 1000,
                        }}
                        pagination={{
                            defaultPageSize: 10,
                            hideOnSinglePage: true,
                            pageSizeOptions: [10, 20, 50, 100],
                        }}
                        footer={() => {
                            return (
                                <>
                                    <div className="flex items-center w-full justify-between gap-[1.25rem] p-[1rem]">
                                        {selectedRowKeys.length > 0 ? (
                                            <button type="button" onClick={handleRemove} className="flex items-center gap-[.5rem]">
                                                <div className="black-round-btn !bg-[#fff] !border !border-[#C72C3B]">
                                                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                                        <path
                                                            d="M20.25 4.5H16.5V3.75C16.5 3.15326 16.2629 2.58097 15.841 2.15901C15.419 1.73705 14.8467 1.5 14.25 1.5H9.75C9.15326 1.5 8.58097 1.73705 8.15901 2.15901C7.73705 2.58097 7.5 3.15326 7.5 3.75V4.5H3.75C3.55109 4.5 3.36032 4.57902 3.21967 4.71967C3.07902 4.86032 3 5.05109 3 5.25C3 5.44891 3.07902 5.63968 3.21967 5.78033C3.36032 5.92098 3.55109 6 3.75 6H4.5V19.5C4.5 19.8978 4.65804 20.2794 4.93934 20.5607C5.22064 20.842 5.60218 21 6 21H18C18.3978 21 18.7794 20.842 19.0607 20.5607C19.342 20.2794 19.5 19.8978 19.5 19.5V6H20.25C20.4489 6 20.6397 5.92098 20.7803 5.78033C20.921 5.63968 21 5.44891 21 5.25C21 5.05109 20.921 4.86032 20.7803 4.71967C20.6397 4.57902 20.4489 4.5 20.25 4.5ZM9 3.75C9 3.55109 9.07902 3.36032 9.21967 3.21967C9.36032 3.07902 9.55109 3 9.75 3H14.25C14.4489 3 14.6397 3.07902 14.7803 3.21967C14.921 3.36032 15 3.55109 15 3.75V4.5H9V3.75ZM18 19.5H6V6H18V19.5ZM10.5 9.75V15.75C10.5 15.9489 10.421 16.1397 10.2803 16.2803C10.1397 16.421 9.94891 16.5 9.75 16.5C9.55109 16.5 9.36032 16.421 9.21967 16.2803C9.07902 16.1397 9 15.9489 9 15.75V9.75C9 9.55109 9.07902 9.36032 9.21967 9.21967C9.36032 9.07902 9.55109 9 9.75 9C9.94891 9 10.1397 9.07902 10.2803 9.21967C10.421 9.36032 10.5 9.55109 10.5 9.75ZM15 9.75V15.75C15 15.9489 14.921 16.1397 14.7803 16.2803C14.6397 16.421 14.4489 16.5 14.25 16.5C14.0511 16.5 13.8603 16.421 13.7197 16.2803C13.579 16.1397 13.5 15.9489 13.5 15.75V9.75C13.5 9.55109 13.579 9.36032 13.7197 9.21967C13.8603 9.07902 14.0511 9 14.25 9C14.4489 9 14.6397 9.07902 14.7803 9.21967C14.921 9.36032 15 9.55109 15 9.75Z"
                                                            fill="#C72C3B"
                                                        />
                                                    </svg>
                                                </div>

                                                <span className="role_btn_text !text-[#C72C3B]">Remove selected</span>
                                            </button>
                                        ) : (
                                            <button type="button" onClick={handleAdd} className="flex items-center gap-[.5rem]">
                                                <div className="black-round-btn">
                                                    <svg className="z-[100]" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                                        <path d="M11.9998 4.7998L11.9998 19.1998M19.1998 11.9998L4.7998 11.9998" stroke="white" strokeWidth="1.5" strokeLinecap="round" />
                                                    </svg>
                                                </div>

                                                <span className="role_btn_text">Add</span>
                                            </button>
                                        )}
                                    </div>
                                </>
                            );
                        }}
                    />
                </section>
            </div>
        </>
    );
}
